<template>
	<transition name="fade">
		<div v-if="isOpen" class="alert" :class="platform">
			<div class="alert-content">
				<div class="inner">
					<div class="title">{{ title }}</div>
					<div class="text">{{ text }}</div>
				</div>

				<div class="actions">
					<a @click.prevent="handleClose" class="action bold" href="">{{ close || t('cancel_popup.cancel') }}</a>
					<a @click.prevent="handleAction" class="action" href="">{{ action }}</a>
				</div>
			</div>
			<div class="overlay"></div>
		</div>
	</transition>
</template>

<script>
import { onBeforeUnmount, watch } from '@vue/runtime-core'
import { useI18n } from 'vue-i18n'
import useApi from '@/composition/api.js'

export default {
	emits: ['onClose', 'onAction'],
	props: {
		isOpen: {
			default: false
		},
		title: {
			required: true
		},
		text: {
			required: true
		},
		close: {},
		action: {
			required: true
		}
	},

	setup(props, { emit }) {
		const { t } = useI18n()
		const api = useApi()
		const platform = api.getPlatform()

		watch(
			() => props.isOpen,
			(value) => {
				if (value) {
					document.body.style.overflow = 'hidden'
				} else {
					document.body.style.overflow = 'auto'
				}
			}
		)

		const handleClose = () => {
			document.body.style.overflow = 'auto'
			emit('onClose')
		}

		const handleAction = () => {
			emit('onAction')
		}

		onBeforeUnmount(() => {
			document.body.style.overflow = 'auto'
		})

		return {
			t,
			handleClose,
			handleAction,
			platform
		}
	}
}
</script>

<style lang="scss" scoped>
.alert {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 102;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 1.5rem;

	&-content {
		width: 100%;
		position: relative;
		z-index: 101;

		margin-left: auto;
		margin-right: auto;
	}

	&.ios & {
		&-content {
			background-color: #e6e6e6;
			border-radius: 13px;
			max-width: 280px;
		}
	}

	&.android & {
		&-content {
			background-color: #fff;
			border-radius: 6px;
			max-width: 300px;
		}
	}
}

.ios {
	.inner {
		padding: 17px 25px;
		text-align: center;
	}

	.title {
		font-weight: 500;
		font-size: 18px;
	}

	.text {
		margin-top: 2px;
	}

	.actions {
		display: flex;
	}

	.action {
		position: relative;
		height: 44px;
		line-height: 44px;
		font-size: 17px;
		color: #007aff;
		// border-radius: 0 0 13px 13px;
		overflow: hidden;
		cursor: pointer;
		display: block;
		text-align: center;
		text-decoration: none;
		width: 50%;

		&.bold {
			font-weight: 500;
		}

		&:last-child {
			border-left: 1px solid #d2d2d2;
		}

		&:after {
			content: '';
			position: absolute;
			left: 0;
			top: 0;
			height: 1px;
			width: 100%;
			display: block;
			background-color: #d2d2d2;
			z-index: 1;
		}
	}
}

.android {
	.inner {
		padding: 16px 24px;
	}

	.title {
		font-size: 24px;
		font-weight: 500;
		letter-spacing: 0.02em;
	}

	.text {
		margin-top: 8px;
		color: #757575;
		font-size: 16px;
		line-height: 1.5rem;
		letter-spacing: 0.03em;
	}

	.actions {
		text-align: right;
		padding: 0 4px;
	}

	.action {
		font-family: inherit;
		font-size: 14px;
		border: none;
		cursor: pointer;
		padding: 8px 12px;
		min-width: 72px;
		line-height: 36px;
		letter-spacing: 0.07em;
		font-weight: 500;
		color: #3f51b5;
		text-transform: uppercase;
		background-color: transparent;
		border-radius: 4px;
		outline: none;
		transition: background-color 0.28s linear;
		will-change: background-color;
		text-decoration: none;
		display: inline-block;
		text-align: center;
	}
}

// .alert {
// 	position: fixed;
// 	top: 0;
// 	left: 0;
// 	width: 100%;
// 	height: 100%;
// 	z-index: 102;
// 	display: flex;
// 	justify-content: center;
// 	align-items: center;
// 	padding: 1.5rem;

// 	&-content {
// 		background-color: #e6e6e6;
// 		width: 100%;
// 		border-radius: 13px;
// 		position: relative;
// 		z-index: 101;
// 		max-width: 280px;
// 		margin-left: auto;
// 		margin-right: auto;
// 		overflow: hidden;
// 	}
// }

// .inner {
// 	padding: 17px 25px;
// 	text-align: center;
// }

// .title {
// 	font-weight: 500;
// 	font-size: 18px;
// }

// .text {
// 	margin-top: 2px;
// }

// .actions {
// 	display: flex;
// }

// .action {
// 	position: relative;
// 	height: 44px;
// 	line-height: 44px;
// 	font-size: 17px;
// 	color: #007aff;
// 	// border-radius: 0 0 13px 13px;
// 	overflow: hidden;
// 	cursor: pointer;
// 	display: block;
// 	text-align: center;
// 	text-decoration: none;
// 	width: 50%;

// 	&.bold {
// 		font-weight: 500;
// 	}

// 	&:last-child {
// 		border-left: 1px solid #d2d2d2;
// 	}

// 	&:after {
// 		content: '';
// 		position: absolute;
// 		left: 0;
// 		top: 0;
// 		height: 1px;
// 		width: 100%;
// 		display: block;
// 		background-color: #d2d2d2;
// 		z-index: 1;
// 	}
// }

.overlay {
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 100;
	position: absolute;
	left: 0;
	top: 0;
}
</style>
